const intEdConfig = {
  name: 'int',
  ampContent: 'https://int.hmhone.app.hmhco.com/content',
  ampLoggedInURL: 'https://int.hmhone.app.hmhco.com/ui/logged-in/',
  ampSignedInURL: 'https://int.hmhone.app.hmhco.com/ui/signed-in/',
  ampLogin: 'https://int.hmhone.app.hmhco.com/ui/login/',
  ampLoginHelp: 'https://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  ampLoginPrivacyPolicy:
    'https://www.hmhco.com/prek-12-products-privacy-policy',
  ampLoginTermsAndConditions:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  hnmLoginHelp: 'http://downloads.hmlt.hmco.com/Help/Flight/LogIn/',
  hnmLoginPrivacyPolicy:
    'https://www.heinemann.com/privacy/?utm_medium=shorturl&utm_source=privacy',
  hnmLoginTermsAndConditions:
    'https://www.heinemann.com/platforms-terms-of-use/?utm_medium=shorturl&utm_source=platform-terms',
  rootUrl: 'https://int.hmhone.app.hmhco.com/ui/',
  loginUrl: 'https://int.hmhone.app.hmhco.com/ui/login/',
  loggedInUrl: 'https://int.hmhone.app.hmhco.com/ui/logged-in/',
  loggedOutUrl: 'https://int.hmhone.app.hmhco.com/ui/login/logged-out/',
  helpUrl: 'http://downloads.hmlt.hmco.com/Help/Ed/LogIn',
  privacyPolicyUrl: 'https://www.hmhco.com/prek-12-products-privacy-policy',
  termsAndConditionsUrl:
    'https://www.hmhco.com/terms-of-use-k12-learning-platforms',
  forgotPasswordUrlPath: '/ui/login/forgot-password/',
  requestSigninDetailsUrlPath: '/ui/login/request-signin-details/',
  earlyAccessUrlPath: '/ui/login/early-access',
  earlyAccessSettingsUrlPath: '/early-access-settings',
  apiEngHostname: 'https://api.int.br.internal',
  apiEngHostnamePublic: 'https://api.int.br.internal',
  assessments: 'https://int.hmhone.app.hmhco.com/api/assessment',
  assignments: 'https://int.hmhone.app.hmhco.com/api/assignment',
  assignmentK8s: 'https://app01.int.tsg.hmhco.com/assignment',
  authorizationApi: 'https://int.hmhone.app.hmhco.com/api/authorization',
  auth0: 'https://hmhco-eng.auth0.com',
  auth0CreateConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso',
  auth0FetchConnectionsHost:
    'http://auth-self-service-setup.int.br.hmheng.io/api/v1/sso/datastore/connection',
  baseURL: 'https://int.hmhone.app.hmhco.com',
  cdsMetadatapipeline: 'https://api.int.eng.hmhco.com/cds-metadatapipeline',
  classcraftSessionData:
    'https://hapi.int.hmhco.com/classcraft-session-data-svc',
  classes: 'https://int.hmhone.app.hmhco.com/ui/classes',
  classesClasses: 'https://int.hmhone.app.hmhco.com/ui/classes/classes',
  clientRegistry: 'https://api.int.eng.hmhco.com/idm-client-registry',
  collaboration: 'collaboration.int.hmhco.com',
  contentProvider: 'https://int.hmhone.app.hmhco.com/ui/#/contentProvider/',
  districtDownloadApi:
    'https://data-district-download-service.staging0.hmheng-ds.br.internal',
  districtDownloadApiK8s:
    'https://hapi.int.hmhco.com/data-district-download-service/',
  ebrCore: 'https://api.int.br.internal/idm-ebr-core',
  ebrUi: 'http://int.hmhone.app.hmhco.com/ebr/',
  edHostname: 'https://int.hmhone.app.hmhco.com/',
  edBaseUrl: 'https://int.hmhone.app.hmhco.com',
  EDSLoginUrl: 'https://hapi.int.hmhco.com/edcore/eds-login',
  EDSResourceUrl:
    'https://app01.int.tsg.hmhco.com/edcore/hmheng-eds-api-gateway',
  grading: 'https://int.hmhone.app.hmhco.com/api/grading/',
  gradingK8s: 'https://hapi.int.hmhco.com/grading-api/',
  getUserUrl: 'https://api.int.br.internal/ids-grid-api/ids/v1',
  hmhHelpCenter: 'http://downloads.hmlt.hmco.com',
  hmoHostname: 'http://my-test.hrw.com/access/',
  hmoLoginPath: 'http://my-test.hrw.com/index.jsp',
  idm: 'https://int.app.sif.identity.api.hmhco.com/openid-connect',
  jasperReporting: 'https://int.hmhone.app.hmhco.com/jasperserver-pro',
  licenses: 'https://int.hmhone.app.hmhco.com/ui/#/licenses',
  liftRoot: 'https://int.hmhone.app.hmhco.com/ui/',
  loginPath: '/ui/login/',
  ltiCache: 'https://api.int.eng.hmhco.com/lti-deep-linking/cache',
  myClasses: 'https://int.hmhone.app.hmhco.com/ui/!my-classes',
  myStuff: 'https://int.hmhone.app.hmhco.com/ui/#/my-stuff/lessons',
  newNotificationsApi: 'https://hapi.int.hmhco.com',
  nweaBaseUrl: 'https://auth.int.nwea.org/adult/login',
  nweaStartPage: 'https://int03-start.mapnwea.org/',
  nweaCommonRosterRedirectUrl:
    'https://int03-admin.mapnwea.org/admin/importprofile/StartNewImportPage.seam',
  oktaConnectionApi:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso',
  oktaEarlyAccessDomainsApi:
    'https://api.int.br.internal/okta-services-gateway/api/v1/early-access',
  oktaFetchConnectionsHost:
    'https://api.int.br.internal/okta-services-gateway/api/v1/sso/idps',
  oktaNewOrg: 'https://int.hmhco.com/okta-services-gateway/api/v1/org', // this is deliberate to prevent a 401 logout on int
  onesearch: 'https://int.hmhone.app.hmhco.com/api/onesearch/v1',
  picker: 'https://int.hmhone.app.hmhco.com/ui/#/picker/',
  plannerHost: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plannerHostNonWaf: 'https://planner-api.staging0.hmheng-csl.br.internal',
  plsAuthors:
    'https://api.int.eng.hmhco.com/pls-services-author/api/v5/authors',
  plsCollections:
    'https://api.int.eng.hmhco.com/pls-services-resource/api/v5/collections',
  plsCollectionsK8:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v5/collections',
  plsLessonRelatedResource:
    'https://api.int.eng.hmhco.com/pls-services-lessonrelatedresource/api/v5/lessonrelatedresources',
  plsLessonRelatedResourceK8:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v5/lessonrelatedresources',
  plsRelatedResources:
    'https://api.int.eng.hmhco.com/pls-services-relatedresource/api/v5/relatedresources',
  plsRelatedResourcesK8:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v5/relatedresources',
  plsResource:
    'https://api.int.eng.hmhco.com/pls-services-resource/api/v5/resources',
  plsResourceK8:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v5/resources',
  edsCoreApp: 'https://app01.int.tsg.hmhco.com/edcore/eds-core-app/',
  edsApiGateway: 'https://hapi.int.hmhco.com/edcore/hmheng-eds-api-gateway/',
  prefixCDS: 'https://cds-metadatapipeline.int.br.hmheng.io',
  reportDownloadK8s: '/reporting-api/v5/programs/schoolAssessment',
  reportDownloadK8sBaseURL: 'https://hapi.int.hmhco.com',
  restApi: 'https://api.int.eng.hmhco.com',
  restGroupLessonApi: 'https://practice-qa.gogetwaggle.com/QA1/Teacher',
  restHapi: 'https://hapi.int.hmhco.com',
  restDMPS: 'https://api.int.br.internal/dmps',
  restDMPSNonWAF: 'https://api.int.br.internal/dmps',
  restELM: 'https://api.int.br.internal/elm/v1',
  restIdsApi: 'https://api.int.br.internal/ids', // for purging users in IDS we need a different API
  restIdsGridApi: 'https://api.int.br.internal/ids-grid-api',
  hcpIdentityApiGateway:
    'https://app01.int.tsg.hmhco.com/hcp-identity-api-gateway',
  restIdsGridApiNonWAF: 'https://api.int.br.internal/ids-grid-api',
  restOAC: 'https://api.int.br.internal/oac/v3',
  restOACNonWAF: 'https://api.int.br.internal/oac/v3',
  restOacV2: 'https://int.hmhone.app.hmhco.com/api/oac/v2',
  restPostPrefix: 'https://int.hmhone.app.hmhco.com',
  restPrefix: 'https://int.hmhone.app.hmhco.com',
  restRecommendation: 'https://api.int.br.internal/recommendation-api',
  restStagingProcessor: 'https://api.int.br.internal/idm-staging-processor',
  restSusApi: 'https://api.int.br.internal/idm-user-api', // for purging users in SUS
  restUdsApi: 'https://api.int.eng.hmhco.com/uds',
  reportingSftpService: 'https://hapi.int.hmhco.com/reporting-sftp-svc',
  rosterDashboard: 'https://int.hmhone.app.hmhco.com/ui/#/roster',
  r180Api: 'https://int.hmhone.app.hmhco.com/api/r180/',
  r180Media: 'https://int.hmhone.app.hmhco.com/r180/media',
  sisHostname: 'https://int.hmhone.app.hmhco.com/',
  sso: 'https://auth-self-service-setup.int.br.hmheng.io',
  ssoInitializeUrl: 'https://api.int.br.internal/okta-ed-sp/initialize',
  storyBook: 'https://int.hmhone.app.hmhco.com/ui/storybook/',
  susAuth: 'https://int.hmhone.app.hmhco.com/api/authorization',
  standardsReportWritableResources: '',
  standardsReportWaggleResources: '',
  tcHostname: 'http://www-int.thinkcentral.com/access/',
  tcLoginPath: 'http://www-int.thinkcentral.com/ePC/start.do',
  linkedAssignments:
    'https://int.hmhone.app.hmhco.com/ui/#/assign-full?resourceId=l_ff9bdd36-f627-4241-8dbc-9f9b4f158f56_c7b06f27-597b-42fc-8169-67247568e97f&programId=IM_NL20_G4&title=Unit+Opener%3A+Place+Value+and+Whole+Number+Operations&backTo=discover%252FIM_NL20_G4%252F1&showSched=true&recBy=NONE&isSgm=false',
  virtualClassroomApi:
    'https://api.int.eng.hmhco.com/vcservice/v2/virtual-classroom/meeting',
  virtualClassroomApiK8: 'https://app01.int.tsg.hmhco.com/vcservice',
  wormhole: 'https://api.int.br.internal/wh-api/graphql',
  wormholek8s: 'https://hapi.int.hmhco.com/wormhole-api/graphql',
  importingService: 'https://api.int.br.internal/idm-api-importing-service',
  apiBaseURL: '',
  featureFlagURL:
    'https://int.hmhone.app.hmhco.com/ui/flags/featureFlagsCohorts.config.json',
  edsAuthorize:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/authorize',
  edsAuthorizationCode:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/authorization-code/callback',
  edsInitUrl:
    'https://app01.int.tsg.hmhco.com/edcore/eds-login/login/initializeUri',
  edsLogoutUrl: 'https://app01.int.tsg.hmhco.com/edcore/eds-login/logout/',
  edsPostLogoutRedirectUrl: 'https://int.hmhone.app.hmhco.com/ui/login/',
  flightLogin: `https://platform.int.heinemann.com/ui/login/`,
  forgotPassword: '/ui/login/forgot-password/',
  requestSigninDetails: '/ui/login/request-signin-details/',
  plsCollaborationArtifacts:
    'https://app01.int.tsg.hmhco.com/collaboration-artifacts-svc',
  planktonBaseUrl: 'https://d16qzots3do3wk.cloudfront.net/',
  edpsUrl: 'https://hapi.int.hmhco.com/edcore/hmheng-eds-api-gateway/',
  plsCoachingTopicURL:
    'https://api.int.eng.hmhco.com/pls-services-resource/api/v1',
  plsCoachingTopicURLK8:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v1',
  plsCoachingTopicURLK8V2:
    'https://app01.int.tsg.hmhco.com/pls-services-resource/api/v2',
  createStudentUrl:
    'https://app01.int.tsg.hmhco.com/ids-grid-api/ids/v1/students',
  iReadApiUrl: 'https://int.hmhone.app.hmhco.com/api/iread',
  plannerURL: 'https://app01.int.tsg.hmhco.com/planner-api/',
  assessmentsK8: 'https://app01.int.tsg.hmhco.com/assessment',
  proctorApiUrl: 'https://int03-colo-gateway.nwea.org',
  testsApiUrl: 'https://int03-colo-gateway.nwea.org',
  NWEA_TOKEN_SWAP_CLIENT_ID: '344e3a6e32b745b8866a60a00f76fa04',
  NWEA_TOKEN_SWAP_SECRET: '78Rgg-NiGhFPnh9kLCLEyFT20Rq4-BqjmMxUwvp9lwk',
  NWEA_TOKEN_SWAP_HOST: 'https://access.auth.int.nwea.org',
  partnerConfigUrl: 'https://int03-colo-gateway.nwea.org',
  waggleApi:
    'https://app01.int.tsg.hmhco.com/waggle-placement-svc/api/v1/waggle',
  plsIntegrationSvc: 'https://app01.int.tsg.hmhco.com/pls-integration-svc',
  ltiDeepLinkingEnrollTeacher:
    'https://api.int.eng.hmhco.com/lti-deep-linking/jitr/enroll/teacher',
  plsActivitySvc: 'https://app01.int.tsg.hmhco.com/pls-activity-svc',
};

module.exports = intEdConfig;
